module.exports = __webpack_public_path__ + "static/media/dashboard-selected.2309657b.svg";